import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  openCortexModal,
  openCortexModalWithPrompt,
} from "../../store/actions/chatbot-actions";
import SparkleIcon from "./SparkleIcon";
import ThinkingIndicator from "../../pages/Assistant/components/ThinkingIndicator";
import "./CortexBar.css";
import { ROUTES } from "../../global/constants/routesConstants";

const CortexBar = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  const streamNotification = useSelector(
    (state) => state?.chatbot?.streamNotification
  );
  const isModalOpen = useSelector(
    (state) => state?.chatbot?.cortexModalOpen
  );
  const isNluEnabled = useSelector(
    (state) => state?.chatbot?.isNluEnabled
  );
  const isStreaming = useSelector(
    (state) => state?.chatbot?.isStreaming
  );

  if (!isNluEnabled || pathname.includes(ROUTES.ASSISTANT)) {
    return null;
  }

  const hasNotification = streamNotification !== null && !isModalOpen;
  const showLoadingState = isStreaming && !isModalOpen;

  const handleBarClick = (e) => {
    e.stopPropagation();
    if (showLoadingState || hasNotification || inputValue.trim() === "") {
      dispatch(openCortexModal());
    } else {
      inputRef.current?.focus();
    }
  };

  const handleButtonClick = (e) => {
    e.stopPropagation();
    if (inputValue.trim()) {
      dispatch(openCortexModalWithPrompt(inputValue.trim()));
      setInputValue("");
    } else {
      dispatch(openCortexModal());
    }
  };

  const handleInputKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      dispatch(openCortexModalWithPrompt(inputValue.trim()));
      setInputValue("");
    }
  };

  return (
    <div className="cortex-bar-container">
      <div className="cortex-bar-wrapper" data-testid="cortex-bar" onClick={handleBarClick}>
        <div className="cortex-bar-icon-circle">
          <SparkleIcon />
        </div>
        {hasNotification && !showLoadingState && (
          <div className="cortex-bar-notification-dot" data-testid="notification-dot" />
        )}
        {showLoadingState ? (
          <div className="cortex-bar-thinking-wrapper">
            <ThinkingIndicator label="Thinking…" />
          </div>
        ) : hasNotification ? (
          <span className="cortex-bar-placeholder cortex-bar-placeholder--notification">
            Your response is ready
          </span>
        ) : (
          <input
            ref={inputRef}
            className="cortex-bar-input"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleInputKeyDown}
            onClick={(e) => e.stopPropagation()}
            placeholder="What can I help you with today?"
            data-testid="cortex-bar-input"
            maxLength={2000}
          />
        )}
        <button className="cortex-bar-ask-btn" onClick={handleButtonClick}>
          {showLoadingState ? "View Progress" : hasNotification ? "View Response" : "Ask Assistant"}
        </button>
      </div>
    </div>
  );
};

export default CortexBar;
